export const ADDRESS_INPUT_TRACKING = {
  ETH_ADDRESS: 'eth_address',
  ENS_NAME: 'ens_name',
  EMAIL: 'email',
}

export const GA_TRACK_CATEGORY = {
  CLAIM: 'claim',
  DROP: 'drop',
  WEBSITE: 'website',
  SECRET: 'secret',
  NAVIGATION_MENU: 'navigation_menu',
  AUTHENTICATION: 'authentication',
}
